import { useMutation } from "@apollo/client"
import MultiSwitchDisclosure from "@pathwright/ux/src/components/form/MultiSwitchDisclosure"
import useTranslate from "@pathwright/ux/src/components/lng/useTranslate"
import { HomeRegistrationFragment } from "@pathwright/graphql-client/src/generated"
import UPDATE_REGISTRATION_MUTATION from "../../registration/graphql/update-registration-mutation"

const GroupNotificationsFormOption = ({
  registration
}: {
  registration: HomeRegistrationFragment
}) => {
  const { t } = useTranslate()
  const discussion = !!registration.send_discussion_notifications
  const dates = !!registration.send_due_notifications

  const [mutation] = useMutation(UPDATE_REGISTRATION_MUTATION)

  async function handleSubmit(values: { discussion: boolean; dates: boolean }) {
    const changes = {
      id: registration.id,
      send_discussion_notifications: !!values.discussion,
      send_due_notifications: !!values.dates
    }

    await mutation({
      variables: changes,
      optimisticResponse: {
        updateRegistration: {
          ...changes,
          __typename: "Registration"
        }
      }
    })
  }

  return (
    <MultiSwitchDisclosure
      singularOption={{
        icon: "bell",
        field: "notifications",
        label: t(
          "registration.notifications.get_notifications",
          "Get Notifications"
        )
      }}
      multiOptions={
        [
          {
            field: "discussion",
            icon: "chat-bubbles",
            label: t("registration.notifications.discussions", "Discussions"),
            value: discussion
          },
          {
            field: "dates",
            icon: "calendar",
            label: t(
              "registration.notifications.date_reminders",
              "Date reminders"
            ),
            value: dates
          }
        ] as const
      }
      onSubmit={handleSubmit}
      py={1.5}
      px={2}
    />
  )
}

export default GroupNotificationsFormOption
